<script setup>
import useHistory from '../composable/useHistory';

const { category } = useHistory();
</script>

<template>
  <a
    v-if="category"
    :href="category.link"
  >
    <span>
      <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" width="12px" height="12px">
        <g transform="matrix(1 0 0 1 -381 -168 )">
          <path d="M 12 6.75  L 12 5.25  L 2.8725 5.25  L 7.061249999999999 1.06125  L 6 0  L 0 6  L 6 12  L 7.061249999999999 10.93875  L 2.8725 6.75  L 12 6.75  Z " fill-rule="nonzero" fill="#a3277b" stroke="none" transform="matrix(1 0 0 1 381 168 )"/>
        </g>
      </svg>
    </span>
    Back to {{ category.name }}
  </a>
</template>

<style scoped>

</style>
